<template>

  <div>
    <div>
      <vxe-form :data="toolbar.formData">
        <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
          <template #default="{ data }">
            <vxe-input v-model="data.searchKey" placeholder="请输入总部名称或编号"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item>
          <template #default>
            <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
            <vxe-button @click="clear">重置</vxe-button>
            <vxe-button status="success" @click="add">新增</vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <div style="overflow: hidden;height: 100%">
      <vxe-table
        stripe
        class="mytable-scrollbar"
        ref="table"
        :data="tableData"
        :height="tableHeight"
        show-overflow
        :row-config="{height: 36,isHover: true,isCurrent:true}"
      >
        <vxe-column type="seq" field="id" title="序号" width="60"></vxe-column>
        <vxe-column title="删除" width="50" show-overflow>
          <template #default="{ row }">
            <vxe-button type="text" icon="fa fa-trash-o" @click="removeRow(row)"></vxe-button>
          </template>
        </vxe-column>
        <vxe-column title="编辑" width="50" show-overflow>
          <template #default="{ row }">
            <vxe-button type="text" icon="fa fa-edit" @click="editRow(row)"></vxe-button>
          </template>
        </vxe-column>
        <vxe-column field="hqCode" title="总部编号" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="hqName" title="总部名称" width="180" sortable show-overflow></vxe-column>
        <vxe-column field="userName" title="成员姓名" width="120" sortable show-overflow></vxe-column>
        <vxe-column field="userMail" title="成员邮箱" width="180" sortable show-overflow></vxe-column>
        <vxe-column field="creatorName" title="创建人" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="creationTime" title="创建时间" width="160"  sortable show-overflow></vxe-column>
      </vxe-table>
    </div>
    <div>
      <vxe-pager
        background
        v-model:current-page="tablePager.currentPage"
        v-model:page-size="tablePager.pageSize"
        :total="tablePager.totalResult"
        @page-change="handlePageChange"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      </vxe-pager>
    </div>
  </div>
  <vxe-modal
    v-model="formInput.isShow"
    width="600"
    height="300"
    @close="findData"
    :title="formInput.title"
    show-zoom resize remember
  >
    <template #default>
      <div>
        <vxe-form
          :data="formInput.formData"
          :rules="formInput.formRules"
          ref="nForm"
        >
          <vxe-form-item title="总部名称" field="hqCode" span="22" title-width="100px">
            <template #default="{ data }">
              <vxe-select transfer v-model="data.hqCode" :options="formInput.hqOptions" placeholder="">
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item span="2">
            <template #default>

            </template>
          </vxe-form-item>
          <vxe-form-item title="成员名称" field="UserMail" span="22" title-width="100px">
            <template #default>
              <vxe-input v-model="formInput.formData.UserMail"  placeholder="请选择成员" readonly
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item span="2">
            <template #default>
              <vxe-button @click="selectUser(2)" >选择</vxe-button>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button @click="save" icon="fa fa-save" status="success">保存
              </vxe-button>

            </template>
          </vxe-form-item>
        </vxe-form>
      </div>

    </template>
  </vxe-modal>

  <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
    <template #default>
      <div>
        <vxe-form>
          <vxe-form-item title="关键字" :item-render="{}">
            <template #default>
              <vxe-input v-model="userTablePager.searchKey" placeholder="请输入姓名或邮箱" clearable></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item>
            <template #default>
              <vxe-button @click="findUserData" @keyup.enter="findUserData">查询</vxe-button>
            </template>
          </vxe-form-item>
          <vxe-form-item>
            <template #default>
              <vxe-button status="primary" @click="confirmSelectUser">确定</vxe-button>
            </template>
          </vxe-form-item>
          <vxe-form-item span="24">
            <template #title>
              <span>已选(</span><span style="color: red;">双击选择</span><span>)</span>
            </template>
            <template #default>
              <div>
                <template v-for="(item,index) in formInput.formData.UserNameEmail" :key="index">
                  <span>{{ item.Name }}</span>
                  <va-icon class="icon-left input-icon" @click="clearUser(item.ID)" name="clear"/>
                </template>
              </div>
            </template>
          </vxe-form-item>
        </vxe-form>
      </div>
      <div>
        <vxe-table
          class="mytable-scrollbar"
          :data="dtUser"
          ref="xTableUser"
          height="300"
          @cell-dblclick="chooseUser"
          highlight-hover-row
          highlight-current-row>
          <vxe-column type="seq" field="Id" title="序号" width="50"></vxe-column>
          <vxe-column field="UserName" title="姓名" width="120" sortable></vxe-column>
          <vxe-column field="JobZb" title="总部" width="100" sortable></vxe-column>
          <vxe-column field="JobName" title="部门" width="120" sortable resizable></vxe-column>
          <vxe-column field="UserMail" title="邮箱" width="200" sortable resizable></vxe-column>
          <vxe-column field="uid" title="uid" width="10" :visible="false"></vxe-column>

        </vxe-table>
      </div>
      <div>
        <vxe-pager
          background
          v-model:current-page="userTablePager.currentPage"
          v-model:page-size="userTablePager.pageSize"
          :total="userTablePager.totalResult"
          @page-change="handlePageChangeUser"
          size="small"
        >
        </vxe-pager>
      </div>

    </template>
  </vxe-modal>

</template>

<script>

import Qs from 'qs'
import {reactive, ref} from 'vue';
import {VXETable} from 'vxe-table'


export default {
  name: "SceneMember",
  components: {},
  data() {
    const pageHeight = window.innerHeight - (65 + 48 + 198) + 'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })
    const userTablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
      searchKey: ''
    })

    const formInput = reactive({
      isShow: false,
      editType: '1',
      title: '新增场景组成员',
      hqOptions: [],
      formData: {
        id: '',
        hqCode: '',
        hqName: '',
        UserName: '',//业务邮箱，返回后台保存值
        UserNameEmail: [], //显示中显示值
        UserMail: '', //选择后的显示值

      }, formRules: {
        hqCode: [
          {required: true, message: '总部不能为空'},
        ],
        UserMail: [
          {required: true, message: '成员不能为空'}]
      }
    })

    return {
      tableData: null,
      userTablePager,
      tablePager,
      toolbar,
      formInput,
      pageHeight,
      tableHeight: 0,
      dtUser: null,
      iShowSelectUser: ref(false),
      userSelectType: 2, //1 多选 2 单选
    }
  },
  methods: {
    add() {
      this.bindHQ();
      this.formInput.isShow = true;
      this.formInput.editType = '1';
      this.formInput.title = '新增场景组成员';
      this.formInput.formData = {
        id: '',
        hqCode: '',
        hqName: '',
        userMail: '',
        userName: '',
        creator: this.getUserId,
        modifier: this.getUserId
      };
    },
    editRow(row) {
      const params = {
        'uid': this.getUserId,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.id]
      };
      this.formInput.isShow = true;

      this.$api.digitalDictManageAPI.getSceneMemberOne(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.isShow = true;
          this.formInput.formData.id = res.data.Data.dataTable[0].id;
          this.formInput.formData.hqCode = res.data.Data.dataTable[0].hqCode;
          this.formInput.formData.hqName = res.data.Data.dataTable[0].hqName;
          this.formInput.formData.UserMail =res.data.Data.dataTable[0].userName+'('+ res.data.Data.dataTable[0].userMail+')';
          this.formInput.formData.UserName = res.data.Data.dataTable[0].userMail;
          this.formInput.formData.UserNameEmail = []
          this.formInput.formData.UserNameEmail.push({
            Name: this.formInput.formData.UserMail.toString(),
            ID: this.formInput.formData.UserName.toString()
          })
          this.formInput.title = '编辑场景组成员';
          this.formInput.editType = '2';//更新
        })
        .catch(error => {
          console.log(error);

        })
    },
    async removeRow(row) {
      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.table;

      if (type === 'confirm') {

        this.$api.digitalDictManageAPI.deleteSceneMember(Qs.stringify({"hqId": row.id}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: "删除成功", status: 'success'});
            $grid.remove(row);
          })
          .catch(error => {
            console.log(error);
          })
      }

    },
    async save() {
      const $rForm = this.$refs.nForm;
      const formErrMap = await $rForm.validate();
      if (formErrMap) {
        return;
      }
      const params = {
        'id': this.formInput.formData.id,
        'hqCode': this.formInput.formData.hqCode,
        'userMail': this.formInput.formData.UserName,
        'creator': this.getUserId,
        'modifier': this.getUserId
      }

      //新增
      if (this.formInput.editType === '1') {
        this.$api.digitalDictManageAPI.addSceneMember(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.alert({content: error, status: 'error'});
            console.log(error);
          });
      } else if (this.formInput.editType === '2') { //更新
        this.$api.digitalDictManageAPI.updateSceneMember(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.message({content: error, status: 'error'});
            console.log(error);
          });
      }
    },
    findUserData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.userTablePager.currentPage,
        'pageSize': this.userTablePager.pageSize,
        'searchKey': [this.userTablePager.searchKey, '']
      };
      this.$api.systemManageAPI.getUserList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          // console.log(res.data.Data);
          this.dtUser = res.data.Data.dataTable;
          this.userTablePager.currentPage = res.data.Data.currentPage;
          this.userTablePager.pageSize = res.data.Data.pageSize;
          this.userTablePager.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    selectUser(type) {
      this.userSelectType = type;
      this.userTablePager.searchKey = '';
      this.findUserData();
      this.iShowSelectUser = true;
    },
    confirmSelectUser() {
      this.iShowSelectUser = false;
    },

    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.digitalDictManageAPI.getSceneMemberList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});

            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);

        })
        .catch(error => {
          console.log(error);

        })
    },
    bindHQ() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 50,
        'searchKey': ['']
      };
      this.$api.digitalDictManageAPI.getHeadquarterList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            console.log(res.data.Message)
            return;
          }
          // console.log(res.data.Data);
          this.formInput.hqOptions = []
          for (const item of res.data.Data.dataTable) {
            this.formInput.hqOptions.push({value: item.hqCode, label: item.hqName});
          }
        })
        .catch(error => {
          console.log(error);

        })
    },
    //删除用户
    clearUser(useremail) {
      let idx = -1;
      if (this.userSelectType == 1) {

        this.formInput.formData.UserNameEmail.forEach(function (item, index) {
          if (item.ID == useremail) {
            idx = index
          }
        });
        let tmpId = [], tmpname = [];
        tmpId = this.formInput.formData.UserMail.toString().split(';');
        tmpname = this.formInput.formData.UserName.toString().split(';');
        tmpId.splice(idx, 1);
        tmpname.splice(idx, 1);
        this.formInput.formData.UserMail = tmpId.join(';');//显示值
        this.formInput.formData.UserName = tmpname.join(';');//邮箱
        let count = 0;
        if (this.formInput.formData.UserName.toString() !== '') {
          count = this.formInput.formData.UserName.toString().split(';').length;
        }
        this.formInput.formData.UserNameEmail = [];
        //debugger
        for (let i = 0; i < count; i++) {
          this.formInput.formData.UserNameEmail.push({
            Name: this.formInput.formData.UserMail.toString().split(';')[i],
            ID: this.formInput.formData.UserName.toString().split(';')[i]
          });
        }
      } else {
        this.formInput.formData.UserName = '';
        this.formInput.formData.UserMail = '';
        this.formInput.formData.UserNameEmail = [];
      }
    },
    //选择用户
    chooseUser() {
      const $table = this.$refs.xTableUser;
      const record = $table.getCurrentRecord();
      if (record == null || record.length == 0) {
        VXETable.modal.message({content: '请选择一行数据', status: 'info'});
        return;
      }
      if (this.userSelectType == 1) { //新增时多选

        //判断是否已选择过
        if (this.formInput.formData.UserName.toString() != '') {
          for (let item of this.formInput.formData.UserName.toString().split(';')) {
            if (item == record.UserMail) {
              VXETable.modal.message({content: '该人员已选择', status: 'warning'});
              return;
            }
          }
        }

        if (this.formInput.formData.UserMail == null || this.formInput.formData.UserMail.toString() == '') {
          this.formInput.formData.UserMail = record.UserName + '(' + record.UserMail + ')';
        } else {
          this.formInput.formData.UserMail += ';' + record.UserName + '(' + record.UserMail + ')';

        }
        if (this.formInput.formData.UserName == null || this.formInput.formData.UserName.toString() == '') {
          this.formInput.formData.UserName = record.UserMail;
        } else {
          this.formInput.formData.UserName += ';' + record.UserMail;
        }

        let count = this.formInput.formData.UserName.toString().split(';').length;
        this.formInput.formData.UserNameEmail = [];
        for (let i = 0; i < count; i++) {
          this.formInput.formData.UserNameEmail.push({
            Name: this.formInput.formData.UserMail.toString().split(';')[i],
            ID: this.formInput.formData.UserName.toString().split(';')[i]
          });
        }
      } else { //编辑时单选

        this.formInput.formData.UserMail = record.UserName + '(' + record.UserMail + ')';
        this.formInput.formData.UserName = record.UserMail;
        this.formInput.formData.UserNameEmail = [];
        this.formInput.formData.UserNameEmail.push({
          Name: this.formInput.formData.UserMail.toString(),
          ID: this.formInput.formData.UserName.toString()
        });
      }
    },
    handlePageChange() {
      this.findData();
    },
    handlePageChangeUser() {
      this.findUserData();
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    clear() {
      this.toolbar.formData.searchKey = ''
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },
  },
  mounted() {
    this.bindHQ();
    this.findData();
    this.formInput.formData.creator = this.getUserId;
    this.formInput.formData.modifier = this.getUserId;
    window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getJobZb() {
      return this.$store.state.jobZb;
    },
    getJobName() {
      return this.$store.state.jobName;
    },
    getUserEmail() {
      return this.$store.state.email;
    },
    getUserId() {
      return this.$store.state.userID;
    }
  }
}

</script>


<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
